import React, { useState } from 'react';
// import { useSelector } from 'react-redux';

import {
  alternativeCareerPath,
  getSafeThreeYearMilestones,
  useThreeYearRoadMapAccordingToSector,
} from '../../hooks/use-roadmap-ai.hooks';
import { useUserProfileContext } from '../../hooks/user-user-profile-context.hooks';
// import { extractUniqueTopSkillsDiverse } from '../../redux/slice/roadmap-ai/roadmap-ai.operations';
// import { RootState } from '../../redux/store';
import { currencyConvertor } from '../../redux/slice/roadmap-ai/roadmap-ai.operations';
import { GenericPopup } from '../Popup/GenericPopup';

import ProfilePopup from './AlternativeRoute';
import { LearningOptionPopup } from './LearningOptionPopup';
import { MicroSteps } from './MircoStepsPopup';
import { RoadmapSteps } from './RoadmapSteps';

type RoadmapProps = {
  sector: string;
};

export const RoadmapPage1: React.FC<RoadmapProps> = ({ sector }) => {
  const [profileOpen, setProfileOpen] = useState(false);
  const userProfileContext = useUserProfileContext();
  const alternatePaths = alternativeCareerPath();
  const [learningOptionOpen, setLearningOptionOpen] = useState(false);
  const [activeButton, setActiveButton] = useState<string>('milestone');
  const [micro_steps, setMicroSteps] = useState(false);
  const [microStepsIndex, setMicroStepsIndex] = useState({ year: '', index: 0 });
  const buttonBase = 'px-6 py-3 rounded-full font-semibold shadow-md hover:shadow-lg transition';

  const rawMilestones = useThreeYearRoadMapAccordingToSector(sector);
  const threeYearMilestones = getSafeThreeYearMilestones(rawMilestones);

  const steps = [
    {
      year: 'YEAR-1',
      note: `${threeYearMilestones.year_1.career_title} ($${
        Number(currencyConvertor(threeYearMilestones.year_1.base_salary)) / 1000
      }k)`,
      color: 'blue',
      data: {
        careerTittle: threeYearMilestones.year_1.career_title ?? 'Sector',
        bestQuality: threeYearMilestones.year_1.best_quality ?? [],
        microSteps: threeYearMilestones.year_1.micro_steps ?? [],
        requiredSkills: threeYearMilestones.year_1.required_skills ?? [],
        targetSalary: `${Number(currencyConvertor(threeYearMilestones.year_1.base_salary)) / 1000}`,
      },
    },
    {
      year: 'YEAR-2',
      note: `${threeYearMilestones.year_2.career_title} ($${
        Number(currencyConvertor(threeYearMilestones.year_2.base_salary)) / 1000
      }k)`,
      color: 'yellow',
      data: {
        careerTittle: threeYearMilestones.year_2.career_title ?? 'Sector',
        bestQuality: threeYearMilestones.year_2.best_quality ?? [],
        microSteps: threeYearMilestones.year_2.micro_steps ?? [],
        requiredSkills: threeYearMilestones.year_2.required_skills ?? [],
        targetSalary: `${Number(currencyConvertor(threeYearMilestones.year_2.base_salary)) / 1000}`,
      },
    },
    {
      year: 'YEAR-3',
      note: `${threeYearMilestones.year_3.career_title} ($${
        Number(currencyConvertor(threeYearMilestones.year_3.base_salary)) / 1000
      }k)`,
      color: 'blue',
      data: {
        careerTittle: threeYearMilestones.year_3.career_title ?? 'Sector',
        bestQuality: threeYearMilestones.year_3.best_quality ?? [],
        microSteps: threeYearMilestones.year_3.micro_steps ?? [],
        requiredSkills: threeYearMilestones.year_3.required_skills ?? [],
        targetSalary: `${Number(currencyConvertor(threeYearMilestones.year_3.base_salary)) / 1000}`,
      },
    },
  ];

  const targetSalary = Number(currencyConvertor(threeYearMilestones.year_1.base_salary)) / 1000;
  // const required_skills = extractUniqueTopSkillsDiverse(userData.roadMap.alternate_careers);

  // Calculate positions of circles

  return (
    <div className=" relative flex z-10 flex-col items-center p-6 md:p-12">
      {/* Heading */}
      <div className="text-center max-w-2xl mb-10">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1B3BB9]">
          Your Living Career Roadmap
        </h2>
        <p className="text-gray-900 mt-2 font-medium text-sm md:text-base">
          See how today’s users can follow real-world success
        </p>
      </div>

      {/* Tabs */}
      <div className="flex justify-center space-x-4 mb-12">
        <button className="px-5 py-2 rounded-full bg-[#1B3BB9] text-white text-sm">
          Early Career
        </button>
      </div>

      {/* Roadmap with connectors */}
      <RoadmapSteps
        steps={steps}
        onYearClick={(year: string, index: number) => {
          setMicroSteps(true);
          setMicroStepsIndex({ index, year });
        }}
      />

      {/* Buttons */}
      <div className="flex flex-col md:flex-row md:justify-between justify-center gap-7 mt-12 md:w-full max-w-5xl">
        {/* Check Milestone */}
        <button
          className={`${buttonBase} ${
            activeButton === 'milestone' ? 'bg-[#FFD600] text-black' : 'bg-[#1B3BB9] text-white '
          } hover:shadow-2xl`}
          onClick={() => setActiveButton('milestone')}
        >
          Check Milestone
        </button>

        {/* View Learning Options */}
        <button
          className={`${buttonBase} ${
            activeButton === 'learning' ? 'bg-[#FFD600] text-black' : 'bg-[#1B3BB9] text-white'
          } hover:shadow-2xl`}
          onClick={() => {
            setActiveButton('learning');
            // your other logic
            setLearningOptionOpen(true);
            setProfileOpen(false);
          }}
        >
          Profile Fit Insights
        </button>

        {/* Check Alternate */}
        <button
          className={`${buttonBase} ${
            activeButton === 'alternate' ? 'bg-[#FFD600] text-black' : 'bg-[#1B3BB9] text-white'
          } hover:shadow-2xl`}
          onClick={() => {
            setActiveButton('alternate');
            setLearningOptionOpen(false);
            setProfileOpen(true);
          }}
        >
          Check Alternate
        </button>
      </div>

      <GenericPopup
        isOpen={profileOpen}
        onClose={() => {
          setProfileOpen(false), setActiveButton('milestone');
        }}
      >
        <ProfilePopup
          name={userProfileContext.name || ''}
          email={userProfileContext.email || ''}
          alternateData={alternatePaths}
        />
      </GenericPopup>

      <GenericPopup
        isOpen={learningOptionOpen}
        onClose={() => {
          setLearningOptionOpen(false), setActiveButton('milestone');
        }}
      >
        <LearningOptionPopup
          imageUrl=""
          name={userProfileContext.name || userProfileContext.email || ''}
          role={threeYearMilestones.year_1.career_title}
          confidence={currencyConvertor(threeYearMilestones.year_1.confidence)}
          wageUplift={threeYearMilestones.year_1.growth_rate}
          salaryTarget={targetSalary ? `$${targetSalary}k Target` : `$0k Target`}
          requiredSkills={threeYearMilestones.year_1.required_skills}
          quality={
            threeYearMilestones.year_1.best_quality ? threeYearMilestones.year_1.best_quality : []
          }
          summary={threeYearMilestones.year_1.short_summary ?? ''}
        />
      </GenericPopup>

      <GenericPopup
        isOpen={micro_steps}
        onClose={() => {
          setMicroSteps(false), setActiveButton('milestone');
        }}
      >
        <MicroSteps
          imageUrl=""
          name={userProfileContext.name || userProfileContext.email || ''}
          role={steps[microStepsIndex.index].data.careerTittle}
          salaryTarget={
            steps[microStepsIndex.index].data.targetSalary
              ? `$${steps[microStepsIndex.index].data.targetSalary}k Target`
              : `$0k Target`
          }
          requiredSkills={steps[microStepsIndex.index].data.requiredSkills}
          microSteps={
            steps[microStepsIndex.index].data.microSteps
              ? steps[microStepsIndex.index].data.microSteps
              : []
          }
        />
      </GenericPopup>
    </div>
  );
};
